(()=>{
    let prevScroll = window.pageYOffset; //初期スクロール位置の設定

    window.addEventListener('scroll', ()=>{
        let currentScroll = window.pageYOffset; //現在スクロール位置の設定

        const header = document.getElementById('header');
        if(!header) return;

        const eleHeight = header.offsetHeight; //header要素の高さを取得
        const threshold = eleHeight * 2; //header要素分の高さを確実に確保するため２倍にしてる

        if(currentScroll > threshold && currentScroll > prevScroll) { //header要素が完全に見えなくなってから、且つスクロールが初期位置よりも大きくなったら
            header.classList.add('DownMove');
            header.classList.remove('UpMove');
        } else if(currentScroll < threshold) { //現在スクロール位置がheader用に確保していた高さより低くなったら
            header.classList.remove('UpMove');
        } else {
            header.classList.add('UpMove');
            header.classList.remove('DownMove');
        }

        prevScroll = currentScroll; //現在のスクロール位置に置き換える
    })
})();
